import { getTokens } from '@utils/apolloTokenUtils'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.hook('apollo:auth', ({ token }) => {
    const tokens = getTokens()
    const accessToken = tokens?.access || ''
    token.value = `Bearer ${accessToken}`
  })
})
